import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CellRenderer, Column } from '@miq/catalog';
import { PropertySet } from '@miq/domain/property-sets';

@Component({
  selector: 'miq-property-set-name-renderer, [miqPropertySetNameRenderer]',
  template: `
    <div class="fx--h fx--juc-start fx--ali-center">
      <!-- principal column -->
      <ng-container *ngIf="data?.is_statistical">
        <!-- unit -->
        <span
          class="statistical-chip fx--mr-4"
          [matTooltip]="'Statistical Property Set'"
          matTooltipPosition="above"
          matTooltipClass="tooltip-action-icon"
        >
          S
        </span>
        &nbsp;
      </ng-container>
    </div>
  `,
  styleUrls: ['./property-set-statistical-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PropertySetStatisticalRendererComponent implements CellRenderer<Column> {
  public data?: PropertySet = null;
  public config?: Column;

  render(): void {
    // required by CellRenderer
  }
}
